import { createContext, useContext, type ReactNode } from 'react';
import { useAppSelectorShallow } from 'store/hooks';
import {
  useActivityInstructionImagesDraft,
  type ActivityInstructionImagesDraft
} from 'hooks/useActivityInstructionImagesDraft';

const ActivityInstructionImagesDraftContext =
  createContext<ActivityInstructionImagesDraft | null>(null);

export function ActivityInstructionImagesDraftProvider({
  children
}: {
  children: ReactNode;
}) {
  const isActive = useAppSelectorShallow(
    (state) => state.setting.isShowMoreOptionsOpened
  );
  const reduxImageUrls = useAppSelectorShallow(
    (state) => state.modal.moreOption.activity?.image_urls
  );
  const draft = useActivityInstructionImagesDraft({
    isActive,
    reduxImageUrls
  });

  return (
    <ActivityInstructionImagesDraftContext.Provider value={draft}>
      {children}
    </ActivityInstructionImagesDraftContext.Provider>
  );
}

export function useActivityInstructionImagesDraftContext(): ActivityInstructionImagesDraft {
  const ctx = useContext(ActivityInstructionImagesDraftContext);
  if (!ctx) {
    throw new Error(
      'useActivityInstructionImagesDraftContext must be used within ActivityInstructionImagesDraftProvider'
    );
  }
  return ctx;
}
